import { computed as s, h as p } from "vue";
import u from "./design-system.es343.js";
import i from "./design-system.es344.js";
import a from "./design-system.es25.js";
import n from "./design-system.es146.js";
const w = {
  name: "DsDropdownNext",
  setup(c, { slots: o, attrs: e }) {
    const { isTouchDevice: t } = n(), r = a({ query: "(max-width: 767px)" }), m = s(() => t.value && r.value);
    return () => p(m.value ? i : u, e, o);
  }
};
export {
  w as default
};
//# sourceMappingURL=design-system.es196.js.map
